const devMode = false; 
const hrefImg = document.querySelectorAll('.href-img');

hrefImg.forEach((item, index) => {
  if (devMode) console.log(item);
  if (item.firstElementChild == null) setForString(item, index);
});

function setForString(item, index) {
  let img = document.createElement('img');
  let text = item.firstChild.textContent;
  img.src = text.trim();
  item.firstChild.remove();
  img.alt = 'img';
  if (devMode) console.log(img);
  hrefImg[index].appendChild(img);
}
